/* ============================================================
   RACC theme global script: age gate + language toggle.
   JP switches the URL to /ja so Shopify (Localize) serves
   Japanese titles and descriptions. UI labels still font-swap.
   ============================================================ */
(function () {
  function onJa() {
    return window.location.pathname === '/ja' || window.location.pathname.indexOf('/ja/') === 0;
  }

  function applyLang(l) {
    document.querySelectorAll('.lang-en').forEach(function (el) { el.classList.toggle('dn', l !== 'en'); });
    document.querySelectorAll('.lang-jp').forEach(function (el) { el.classList.toggle('dn', l !== 'jp'); });
    var root = document.getElementById('html-root');
    if (root) root.lang = (l === 'jp') ? 'ja' : 'en';
    document.querySelectorAll('.lang-btn').forEach(function (b) { b.classList.remove('active'); });
    var on = document.getElementById('lang-' + l);
    if (on) on.classList.add('active');
    if (typeof window.raccPageSetLang === 'function') { try { window.raccPageSetLang(l); } catch (e) {} }
  }

  // Go to the Japanese or default version of the current page.
  function goToLocale(l) {
    var path = window.location.pathname;
    var rest = window.location.search + window.location.hash;
    var bare = onJa() ? path.replace(/^\/ja/, '') : path;
    if (bare === '') bare = '/';
    var target = (l === 'jp') ? ('/ja' + (bare === '/' ? '' : bare)) : bare;
    window.location.href = target + rest;
  }

  window.raccSetLang = function (l) {
    sessionStorage.setItem('racc_lang', l);
    var needJa = (l === 'jp');
    // Only reload if the URL locale does not already match the choice.
    if (needJa !== onJa()) {
      goToLocale(l);
      return;
    }
    applyLang(l);
  };

  window.raccEnterSite = function (l) {
    sessionStorage.setItem('racc_ok', '1');
    sessionStorage.setItem('racc_lang', l);
    var gate = document.getElementById('age-gate');
    if (gate) gate.classList.add('dismissed');
    var needJa = (l === 'jp');
    if (needJa !== onJa()) {
      goToLocale(l);
      return;
    }
    applyLang(l);
  };

  window.raccDenyEntry = function () {
    var gate = document.getElementById('age-gate');
    if (gate) gate.style.display = 'none';
    var no = document.getElementById('no-age');
    if (no) no.classList.add('show');
  };

  window.raccToggleMobileNav = function () {
    var m = document.getElementById('nav-mobile');
    if (m) m.classList.toggle('open');
  };

  // On load: skip the gate if already passed, and set language from the URL.
  document.addEventListener('DOMContentLoaded', function () {
    // The URL is the source of truth. /ja means Japanese.
    var lang = onJa() ? 'jp' : 'en';
    sessionStorage.setItem('racc_lang', lang);
    if (sessionStorage.getItem('racc_ok')) {
      var gate = document.getElementById('age-gate');
      if (gate) gate.classList.add('dismissed');
    }
    applyLang(lang);
  });
})();